<template>
  <div class="text-left w-100">
    <div class="mt-4 mb-0 mb-md-6 w-100">
      <div class="d-flex align-center w-100">
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
          v-if="this.$store.state.loggedUser.job == 'RESEARCHER'"
        >
          Voir les étude alimentaire
        </h1>
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
          v-if="this.$store.state.loggedUser.job == 'CONSUMER'"
        >
          Voir vos challenges
        </h1>
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
          v-else
        >
          Voir votre plan d'action
        </h1>
      </div>

      <div class="d-flex alig-center" v-if="loggedUser.job == 'COOK'">
        <label class="switch">
          <input type="checkbox" @click="toggleSwitch" />
          <div class="slider round"></div>
        </label>
      </div>
    </div>

    <!-- Liste des études alimentaires -->
    <div v-if="showCalendar">
      <ActionCalendar />
    </div>
    <div class="mt-4" v-else>
      <ActionPlanPagination />
    </div>
  </div>
</template>

<script>
import ActionCalendar from "./ActionCalendar.vue"
import ActionPlanPagination from "./ActionPlanPagination.vue"

export default {
  name: "ManagementPage",
  components: {
    ActionCalendar,
    ActionPlanPagination,
  },
  data() {
    return {
      showCalendar: false,
      inProgress: false,
    }
  },
  methods: {
    fetchCurrentPage() {
      this.inProgress = true
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      this.$store
        .dispatch("fetchAction", { offset: this.offset, search: this.searchTerm })
        .then((response) => {
          this.actions = response
          this.actionCount = response.length
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
        .finally(() => {
          this.inProgress = false
        })
    },
    toggleSwitch() {
      this.showCalendar = !this.showCalendar
      console.log(this.showCalendar)
    },
  },
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
}
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 23px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #101010;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.slider.round {
  border-radius: 23px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
